
const filterShopTheLook = (styleNumber) => {
  const lauraTops = [
    3010336, 3010337, 3010338,
    3030336, 3030337, 3030338,
    4010336, 4010337, 4010338,
    4030336, 4030337, 4030338,
    5010336, 5010337, 5010338,
    5030336, 5030337, 5030338
  ];

  const lauraBottoms = [
    3010331, 3010332, 3010333, 3010334,
    3030331, 3030332, 3030333, 3030334,
    4010331, 4010332, 4010333, 4010334,
    4030331, 4030332, 4030333, 4030334,
    5010331, 5010332, 5010333, 5010334,
    5030331, 5030332, 5030333, 5030334
  ]; 

  const lauraJacketsBlazers = [
    3010335, 3030335, 4010335, 4030335, 
    5010335, 5030335, 3010331, 3030331, 
    4030331, 4010331, 5010331, 5030331
  ];

  const lauraSweatersCardigans = [
    3010339, 4010339, 5010339, 
    3030339, 4030339, 5030339
  ];

  const mltops =  [
    6010336, 6010337, 6010338, 
    6030336, 6030337, 6030338
  ];  

  const mlBottoms = [
    6010331, 6010332, 6010333, 6010334,
    6030331, 6030332, 6030333, 6030334
  ];

  const mlJacketsBlazers = [
    6010335, 6030335, 6010331, 6030331
  ];

  const MLSweatersCardigans = [
    6010339, 6030339
  ];

  let shopTheLookFilters = [];  
    
    if (lauraTops.includes(styleNumber)) {      
      shopTheLookFilters = [
        3010331, 3010332, 3010333, 3010334,
        3030331, 3030332, 3030333, 3030334,
        4010331, 4010332, 4010333, 4010334,
        4030331, 4030332, 4030333, 4030334,
        5010331, 5010332, 5010333, 5010334,
        5030331, 5030332, 5030333, 5030334,
        3010335, 3030335, 4010335, 4030335,
        5010335, 5030335, 5030228, 5030229,
        3010220, 3010221, 3010222, 3010223,
        3010226, 3010227, 3010228, 3010229,
        3030220, 3030221, 3030222, 3030223,
        3030226, 3030227, 3030228, 3030229,
        4010220, 4010221, 4010222, 4010223,
        4010226, 4010227, 4010228, 4010229,
        4030220, 4030221, 4030222, 4030223,
        4030226, 4030227, 4030228, 4030229,
        5010220, 5010221, 5010222, 5010223,
        5010226, 5010227, 5010228, 5010229,
        5030220, 5030221, 5030222, 5030223,
        5030226, 5030227];
    }else if(lauraBottoms.includes(styleNumber)){      
      shopTheLookFilters = [
        3010336, 3010337, 3010338, 3010339,
        3030336, 3030337, 3030338, 3030339,
        4010336, 4010337, 4010338, 4010339,
        4030336, 4030337, 4030338, 4030339,
        5010336, 5010337, 5010338, 5010339,
        5030336, 5030337, 5030338, 5030339,
        3010335, 3030335, 4010335, 4030335,
        5010335, 5030335, 5030226, 5030227,
        3010331, 3030331, 4030331, 4010331,
        5010331, 5030331, 5030228, 5030229,
        3010220, 3010221, 3010222, 3010223,
        3010226, 3010227, 3010228, 3010229,
        3030220, 3030221, 3030222, 3030223,
        3030226, 3030227, 3030228, 3030229,
        4010220, 4010221, 4010222, 4010223,
        4010226, 4010227, 4010228, 4010229,
        4030220, 4030221, 4030222, 4030223,
        4030226, 4030227, 4030228, 4030229,
        5010220, 5010221, 5010222, 5010223,
        5010226, 5010227, 5010228, 5010229,
        5030220, 5030221, 5030222, 5030223];
    }else if(lauraJacketsBlazers.includes(styleNumber)){      
      shopTheLookFilters = [
        3010331, 3010332, 3010333, 3010334,
        3030331, 3030332, 3030333, 3030334,
        4010331, 4010332, 4010333, 4010334,
        4030331, 4030332, 4030333, 4030334,
        5010331, 5010332, 5010333, 5010334,
        5030331, 5030332, 5030333, 5030334,
        3010336, 3010337, 3010338, 3010339,
        3030336, 3030337, 3030338, 3030339,
        4010336, 4010337, 4030338, 4030339,
        5010336, 5010337, 5010338, 5010339,
        5030336, 5030337, 5030338, 5030339,
        3010101, 4010101, 5010101, 5030101,
        3030101, 4030101];
    }else if(lauraSweatersCardigans.includes(styleNumber)){      
        shopTheLookFilters =  [
          3010331, 3010332, 3010333, 3010334,
          3030331, 3030332, 3030333, 3030334,
          4010331, 4010332, 4010333, 4010334,
          4030331, 4030332, 4030333, 4030334,
          5010331, 5010332, 5010333, 5010334,
          5030331, 5030332, 5030333, 5030334,
          3010335, 3030335, 4010335, 4030335,
          5010335, 5030335, 5030338, 5030337,
          3010220, 3010221, 3010222, 3010223,
          3010226, 3010227, 3010228, 3010229,
          4010220, 4010221, 4010222, 4010223,
          4010226, 4010227, 4010228, 4010229,
          4030220, 4030221, 4030222, 4030223,
          4030226, 4030227, 4030228, 4030229,
          5010220, 5010221, 5010222, 5010223,
          5010226, 5010227, 5010228, 5010229,
          5030220, 5030221, 5030222, 5030223,
          5030226, 5030227, 5030228, 5030229,
          3010336, 3010337, 3010338, 5030336,
          3030336, 3030337, 3030338, 5010338,
          4010336, 4010337, 4010338, 5010337,
          4030336, 4030337, 4030338, 5010336];
    }else if(mltops.includes(styleNumber)){
      shopTheLookFilters = [
        6010331, 6010332, 6010333, 6010334,
        6030331, 6030332, 6030333, 6030334,
        6010335, 6030335, 6030228, 6030229,
        6010220, 6010221, 6010222, 6010223,
        6010226, 6010227, 6010228, 6010229,
        6030220, 6030221, 6030222, 6030223,
        6030226, 6030227];
    }else if(mlBottoms.includes(styleNumber)){
      shopTheLookFilters = [
        6010336, 6010337, 6010338, 6010339,
        6030336, 6030337, 6030338, 6030339,
        6010335, 6030335, 6030228, 6030229,
        6010331, 6030331, 6030227, 6030226,
        6010220, 6010221, 6010222, 6010223,
        6010226, 6010227, 6010228, 6010229,
        6030220, 6030221, 6030222, 6030223];
    }else if(mlJacketsBlazers.includes(styleNumber)){
      shopTheLookFilters = [
        6010331, 6010332, 6010333, 6010334,
        6030331, 6030332, 6030333, 6030334,
        6010336, 6010337, 6010338, 6010339,
        6030336, 6030337, 6030338, 6030339,
        6010101, 6030101];
    }else if(MLSweatersCardigans.includes(styleNumber)){
      shopTheLookFilters = [
        6010331, 6010332, 6010333, 6010334,
        6030331, 6030332, 6030333, 6030334,
        6010335, 6030335, 6030338, 6030337,
        6010220, 6010221, 6010222, 6010223,
        6010226, 6010227, 6010228, 6010229,
        6030220, 6030221, 6030222, 6030223,
        6030226, 6030227, 6030228, 6030229,
        6010336, 6010337, 6010338, 6030336];
    }

  return shopTheLookFilters;
};

export default filterShopTheLook;
